export default "__VITE_ASSET__Bn_a_2D4__"